<template>
  <vbt-content-box
    :loading="loading"
    :loading-error="loadingError"
    title="Package Information"
  >
    <template #toolbar>
      <v-menu
        v-if="packageReturn.resendToCustomer"
        open-on-hover
        bottom
      >
        <template #activator="{ on }">
          <v-btn
            x-small
            color="success"
            v-on="on"
          >
            Generate shipping label
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="labelFormat in labelFormatsOptions"
            :key="labelFormat"
            @click="generateShippingLabel(labelFormat)"
          >
            <v-list-item-title>
              {{ labelFormat }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>

    <v-layout align-center>
      <v-flex sm4>
        <v-layout align-center>
          <strong class="mr-2">
            Tracking Number:
          </strong>

          {{ packageReturn.trackingNumber }}
        </v-layout>
      </v-flex>

      <v-flex sm4>
        <v-layout align-center>
          <strong class="mr-2">
            Create Date:
          </strong>

          {{ formatDate(packageReturn.createDate) }}
        </v-layout>
      </v-flex>

      <v-flex sm4>
        <v-layout align-center>
          <strong class="mr-2">
            Expire Date:
          </strong>

          {{ formatDate(packageReturn.expireDate) }}
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout
      align-center
      class="mt-2"
    >
      <v-flex sm4>
        <v-layout align-center>
          <strong class="mr-2">
            Reason:
          </strong>

          {{ packageReturn.reason }}
        </v-layout>
      </v-flex>

      <v-flex sm4>
        <v-layout align-center>
          <strong class="mr-2">
            Resend To Customer:
          </strong>

          <kernel-package-return-state :state="packageReturn.resendToCustomer" />
        </v-layout>
      </v-flex>

      <v-flex sm4>
        <v-layout align-center>
          <strong class="mr-2">
            Product Reshipable:
          </strong>

          <kernel-package-return-state :state="packageReturn.productReshipable" />
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout
      align-center
      class="mt-2"
    >
      <v-flex sm4>
        <v-layout align-center>
          <strong class="mr-2">
            Description:
          </strong>

          {{ packageReturn.description }}
        </v-layout>
      </v-flex>
    </v-layout>

    <vbt-dialog
      v-model="shippingLabelResultDialog"
      title="Shipping Label"
      hide-submit-btn
      width="900px"
    >
      <vbt-code
        :value="shippingLabelResultCode"
        readonly
      />
    </vbt-dialog>
  </vbt-content-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { useIncludedLoading } from '@mixins/factories';

import { formatDate, wrapToLoadingFn } from '@helpers';

import { namespace as EnumsNamespace } from '@store/modules/enums.types';
import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import { namespace as PackageReturnsNamespace } from '../store.types';

import { PackageReturnsApiService } from '../_services/packageReturns.api.service';

import KernelPackageReturnState from './KernelPackageReturnState.vue';

export default {
  name: 'KernelPackageReturnInfo',

  components: {
    KernelPackageReturnState,
  },

  mixins: [
    useIncludedLoading(),
  ],

  data() {
    return {
      shippingLabelResultCode: '',
      shippingLabelResultDialog: false,
    };
  },

  computed: {
    ...mapState(LocationsNamespace, ['suffix']),

    ...mapState(PackageReturnsNamespace, {
      packageReturn: ({ packageReturn }) => packageReturn,
    }),

    ...mapGetters(EnumsNamespace, ['labelFormatsEnumByValue']),

    labelFormatsOptions() {
      return Object.keys(this.labelFormatsEnumByValue);
    },
  },

  methods: {
    generateShippingLabel(labelFormat) {
      this.$VBlackerTheme.alert.warning({
        text: `Generate label in ${labelFormat} format?`,
      }, () => this.wrapToLoadingFn({
        req: PackageReturnsApiService.generateShippingLabel.bind({}, {
          trackingNumber: this.packageReturn.trackingNumber,
          format: labelFormat,
          suffix: this.suffix,
        }),
        loadingSpinnerType: 'fullscreen',
        onSuccess: ({ data }) => {
          this.shippingLabelResultCode = data;
          this.shippingLabelResultDialog = true;
        },
      }));
    },

    formatDate,
    wrapToLoadingFn,
  },
};
</script>
